<section class="flex flex-col items-center w-full pb-[240px]">
    <img src="images/landing/why-semnexus.svg" alt="why semnexus" class="h-[45px] sm:h-[50px]" />
    <div class="mt-[24px] px-4 sm:px-[20%] text-center text-sm sm:text-base">
        SEM Nexus builds and markets great mobile apps. We utilize a methodical and agile development process to
        ensure quality while keeping costs low and employ a comprehensive data-driven marketing process that allows us
        to build a niche-relevant user base around your product.
    </div>
    <div class="flex flex-col sm:flex-row w-full items-center justify-center gap-[20px] mt-[22px]">
        <app-button buttonText="services" (clicked)="goToSection.emit('services')"></app-button>
        <app-button buttonText="case studies" (clicked)="goToSection.emit('case-studies')"></app-button>
    </div>
</section>